import { Injectable } from '@angular/core';
import { RevenueComponent, RevenuePeriod } from '@vendasta/sales-orders';
import { SummaryItem, UILineItem } from '../order-form/order-item-list/interface';

@Injectable()
export class OrderSummaryService {
  static getPriceSummary(items: UILineItem[]): { items: SummaryItem[]; includesUndefinedPricing: boolean } {
    if (!items) {
      return { items: [], includesUndefinedPricing: false };
    }
    let includesUndefinedPricing = false;
    const summaryItems = items.reduce((currentArray, item) => {
      if (item.lineItem.currentRevenue?.revenueComponents?.length === 0) {
        includesUndefinedPricing = true;
        return currentArray;
      }

      item.lineItem.currentRevenue.revenueComponents.map((revenueComponent) => {
        if (!revenueComponent || revenueComponent.value < 0) {
          includesUndefinedPricing = true;
          return;
        }

        const period = revenueComponent.period || RevenuePeriod.ONETIME;
        const isStartingRevenue = revenueComponent.isStartingRevenue;

        const summaryItem: SummaryItem = {
          currencyCode: item.lineItem.currencyCode,
          currency: item.lineItem.currency,
          revenueComponents: [],
          billingId: item.billingId,
        };

        const quantifiedPrice = (revenueComponent.value || 0) * item.lineItem.quantity;
        summaryItem.revenueComponents.push(
          new RevenueComponent({
            value: quantifiedPrice,
            period: period,
            isStartingRevenue: isStartingRevenue,
          }),
        );

        currentArray.push(summaryItem);
      });
      return currentArray;
    }, []);
    return { items: summaryItems, includesUndefinedPricing: includesUndefinedPricing };
  }
}
